/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes/'
export default StyleSheet.create({
    container: {
        flex: 1, borderBottomColor: '#CDCDCD', borderBottomWidth: 1
    },
    textStyle: {
        color: Fonts.style.color.baseColor,
        fontSize: 16,
        fontFamily: Fonts.style.font.light
    },
    content: { flexDirection: 'row', height: 44, alignItems: 'center' },
    image:
        {
            width: 30, height: 30,

            borderColor: Fonts.style.color.disable,
            borderRadius: 15,
            borderWidth: 1
        }

})
